"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PlaneRestrictionApi_angularRestrictionApi, _PlaneRestrictionApi_axisRestrictionApi, _PlaneRestrictionApi_gridRestrictionApi, _PlaneRestrictionApi_planeRestriction;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaneRestrictionApi = void 0;
const AbstractRestrictionApi_1 = require("../AbstractRestrictionApi");
const AngularRestrictionApi_1 = require("./snap/AngularRestrictionApi");
const AxisRestrictionApi_1 = require("./snap/AxisRestrictionApi");
const GridRestrictionApi_1 = require("./snap/GridRestrictionApi");
class PlaneRestrictionApi extends AbstractRestrictionApi_1.AbstractRestrictionApi {
    // #endregion Properties (4)
    // #region Constructors (1)
    constructor(restriction) {
        super(restriction);
        // #region Properties (4)
        _PlaneRestrictionApi_angularRestrictionApi.set(this, void 0);
        _PlaneRestrictionApi_axisRestrictionApi.set(this, void 0);
        _PlaneRestrictionApi_gridRestrictionApi.set(this, void 0);
        _PlaneRestrictionApi_planeRestriction.set(this, void 0);
        __classPrivateFieldSet(this, _PlaneRestrictionApi_planeRestriction, restriction, "f");
        __classPrivateFieldSet(this, _PlaneRestrictionApi_gridRestrictionApi, new GridRestrictionApi_1.GridRestrictionApi(restriction.gridRestriction), "f");
        __classPrivateFieldSet(this, _PlaneRestrictionApi_angularRestrictionApi, new AngularRestrictionApi_1.AngularRestrictionApi(restriction.angularRestriction), "f");
        __classPrivateFieldSet(this, _PlaneRestrictionApi_axisRestrictionApi, new AxisRestrictionApi_1.AxisRestrictionApi(restriction.axisRestriction), "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (9)
    get angularRestrictionApi() {
        return __classPrivateFieldGet(this, _PlaneRestrictionApi_angularRestrictionApi, "f");
    }
    get axisRestrictionApi() {
        return __classPrivateFieldGet(this, _PlaneRestrictionApi_axisRestrictionApi, "f");
    }
    get gridRestrictionApi() {
        return __classPrivateFieldGet(this, _PlaneRestrictionApi_gridRestrictionApi, "f");
    }
    get origin() {
        return __classPrivateFieldGet(this, _PlaneRestrictionApi_planeRestriction, "f").origin;
    }
    set origin(value) {
        __classPrivateFieldGet(this, _PlaneRestrictionApi_planeRestriction, "f").origin = value;
    }
    get vectorU() {
        return __classPrivateFieldGet(this, _PlaneRestrictionApi_planeRestriction, "f").vectorU;
    }
    set vectorU(value) {
        __classPrivateFieldGet(this, _PlaneRestrictionApi_planeRestriction, "f").vectorU = value;
    }
    get vectorV() {
        return __classPrivateFieldGet(this, _PlaneRestrictionApi_planeRestriction, "f").vectorV;
    }
    set vectorV(value) {
        __classPrivateFieldGet(this, _PlaneRestrictionApi_planeRestriction, "f").vectorV = value;
    }
}
exports.PlaneRestrictionApi = PlaneRestrictionApi;
_PlaneRestrictionApi_angularRestrictionApi = new WeakMap(), _PlaneRestrictionApi_axisRestrictionApi = new WeakMap(), _PlaneRestrictionApi_gridRestrictionApi = new WeakMap(), _PlaneRestrictionApi_planeRestriction = new WeakMap();
//# sourceMappingURL=PlaneRestrictionApi.js.map